import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { APIService } from '@services/api/common-services';
import { APICONFIG } from '@config/api.config';
import { IContractorDetailsResponse } from '.';

interface ContractorPhone {
	phone: string;
}

interface IContractorDetailsQueryResponse {
	data?: IContractorDetailsResponse;
	mutate: UseMutateFunction<IContractorDetailsResponse, Error, ContractorPhone, unknown>;
	error: Error | null;
	isError: boolean;
	isPending: boolean;
}

export const useContractorDetailsQuery = (): IContractorDetailsQueryResponse => {
	const fetchContractorDetails = async (params: ContractorPhone): Promise<IContractorDetailsResponse> => {
		const url = `${APICONFIG.SS_CONTRACTOR}?phone=${params.phone}`;
		// Try both response structures - the API might return data directly or wrapped
		const response = await APIService.getData<
			IContractorDetailsResponse | { message: string; data: IContractorDetailsResponse }
		>(url);

		// Check if response has data property (wrapped) or is direct
		if (response && typeof response === 'object' && 'data' in response) {
			return (response as { message: string; data: IContractorDetailsResponse }).data;
		}

		// Return direct response if it's the contractor details object
		return response;
	};

	const { mutate, error, isError, isPending, data } = useMutation({
		mutationFn: fetchContractorDetails,
	});

	return {
		data,
		mutate,
		error,
		isError,
		isPending,
	};
};
